import { CHECK_NAME_LABELS } from "../utils/checkLabels";

export interface LandingCheckItem {
  checkName: string;
  checkNameDescription: string;
}

const FALLBACK_ORDER = [
  "INN_FOUND",
  "COMPANY_NAME_RESOLVED",
  "PRIVACY_POLICY_FOUND",
  "IS_DOMAIN_RUSSIAN",
  "COOKIES_FOUND",
  "COOKIES_AGREEMENT_FOUND",
  "PRIVATE_DATA_FORMS_FOUND",
  "GOOGLE_ANALYTICS_REQUESTS_FOUND",
] as const;

export const FALLBACK_LANDING_CHECKS: LandingCheckItem[] = FALLBACK_ORDER.map((checkName) => ({
  checkName,
  checkNameDescription: CHECK_NAME_LABELS[checkName] ?? checkName,
}));
